import _classCallCheck from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectWithoutProperties from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["order", "dateLiteral", "dateLiteralWord", "timeLiteral", "separator", "weekLiteral", "msLiteral"];
var _KEY_UNIT_MAP;
var KEY_UNIT_MAP = (_KEY_UNIT_MAP = {}, _defineProperty(_KEY_UNIT_MAP, "y" /* Year */, "year"), _defineProperty(_KEY_UNIT_MAP, "M" /* Month */, "month"), _defineProperty(_KEY_UNIT_MAP, "w" /* Week */, "week"), _defineProperty(_KEY_UNIT_MAP, "d" /* Day */, "day"), _defineProperty(_KEY_UNIT_MAP, "h" /* Hour */, "hour"), _defineProperty(_KEY_UNIT_MAP, "m" /* Minute */, "minute"), _defineProperty(_KEY_UNIT_MAP, "s" /* Second */, "second"), _defineProperty(_KEY_UNIT_MAP, "S" /* Milisecond */, "millisecond"), _KEY_UNIT_MAP);
var UNITS = ["year" /* Year */, "month" /* Month */, "week" /* Week */, "day" /* Day */, "hour" /* Hour */, "minute" /* Minute */, "second" /* Second */, "millisecond" /* Millisecond */];

var FORMATS = ["numeric" /* Numeric */, "2-digit" /* Double */, "short" /* Short */, "long" /* Long */];
/**
 * @constant
 * @description conversion rates between different units in descending order
 * @private
 */
var RATES = [365, 30, 7, 24, 60, 60, 1000, 1];

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @name _isInteger
 * @summary predicator to determine if a value can be parsed to integer
 * @private
 *
 * @param {any} value - the value to be parsed
 * @returns {boolean} if the value is integer
 */
function _isInteger(value) {
  return !isNaN(parseInt(value, 10));
}
/**
 * @name _isValidUnit
 * @summary predicator to check if a string can be parsed to integer
 * @private
 *
 * @param {any} value - the value to be checked
 * @returns {boolean} if the value is a valid {@link #UNIT}
 */
function _isValidUnit(unit) {
  return UNITS.includes(unit);
}
/**
 * @name _isValidDate
 * @summary predicator to check if a date is valid
 * @private
 *
 * @param {any} value - the date to be checked
 * @returns {boolean} if the value is a valid date
 */
function _isValidDate(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}
/**
 * @name _padString
 * @summary padding a string to fixed length with '0' to the left
 * @private
 *
 * @param {number | string} value - the number to be padded
 * @returns {boolean} if the value is a valid date
 */
function _padString(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return ('0'.repeat(length) + String(value)).slice(-length);
}

/**
 *
 * @name addDuration
 * @summary Add a duration to the given date
 * @description
 * Return the date with duration offset from the given date
 * Time math: millisecond, second, minute, hour, day, week
 * Calendar math: month, year (the day value is retained)
 * The duration parts are added in ascending order from ms to year
 * Use a negative integer for subtraction
 *
 * @param {number | string | Date} base - the original date
 * @param {number} n - integer, the number of units to be added
 * @param {UNIT} unit - the unit of time, {@link #UNIT}
 * @returns {Date} the final date with added time
 * @throws {TypeError} Invalid number or unit
 *
 * @example
 * const result = addDuration(Date.now(), {year: 1, month: 1, day: 1})
 */
function addDuration(base, parts) {
  var date = new Date(base);
  for (var i = UNITS.length; i > 0; i--) {
    var unit = UNITS[i - 1];
    if (parts[unit]) {
      date = addUnit(date, parts[unit], unit);
    }
  }
  return date;
}
/**
 *
 * @name addUnit
 * @summary Add some units of time to the given date
 * @description
 * Return the date n unit of time from the given date
 * Time math: millisecond, second, minute, hour, day, week
 * Calendar math: month, year (the day value is retained)
 * Use a negative integer for subtraction
 *
 * @param {number | string | Date} base - the original date
 * @param {number} n - integer, the number of units to be added
 * @param {UNIT} unit - the unit of time, {@link #UNIT}
 * @returns {Date} the final date with added time
 * @throws {TypeError} invalid number or unit
 *
 * @example
 * const tomorrow = addUnit(Date.now(), 1, 'day');
 */
function addUnit(base, n, unit) {
  var date = new Date(base);
  if (!_isValidDate(date) || !_isInteger(n) || !_isValidUnit(unit)) {
    throw new TypeError('Invalid number or unit');
  }
  switch (unit) {
    case "millisecond" /* Millisecond */:
      date.setMilliseconds(date.getMilliseconds() + n);
      break;
    case "second" /* Second */:
      date.setSeconds(date.getSeconds() + n);
      break;
    case "minute" /* Minute */:
      date.setMinutes(date.getMinutes() + n);
      break;
    case "hour" /* Hour */:
      date.setHours(date.getHours() + n);
      break;
    case "day" /* Day */:
      date.setDate(date.getDate() + n);
      break;
    case "week" /* Week */:
      date.setDate(date.getDate() + n * 7);
      break;
    // year is treated as multiples of month
    case "year" /* Year */:
      n *= 12;
    // always keep the original day value
    case "month" /* Month */:
      var dateValue = date.getDate();
      date.setMonth(date.getMonth() + n + 1, 0);
      date.setDate(Math.min(dateValue, date.getDate()));
  }
  return date;
}

/**
 *
 * @name startOf
 * @summary Return the start of a given time unit for the given date
 * @description
 * Return the start date of year/month/day/hour/... for a given date
 * The result will be in the local timezone.
 *
 * @param {UNIT} unit - the start of this unit, {@link #UNIT}
 * @param {number | string | Date} base - the original date
 * @param {WeekOption} [options={startDay: 1}] - to specify the start day of a week, defaults to `Monday`
 * @returns {Date} the end date of the unit
 * @throws {TypeError} invalid unit or date or start day
 *
 * @example
 * const lastDayOfMonth = endOf('month', Date.now())
 * // if we want the week to start on Sunday
 * const endOfThisWeek = endOf('week', Date.now(), {startDay: 0})
 */
function startOf(unit, base) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    startDay: 1
  };
  var date = new Date(base);
  if (!_isValidUnit(unit) || !_isValidDate(date) || !_isInteger(options.startDay)) {
    throw new TypeError('Invalid unit or date or start day');
  }
  var dayOfWeek = date.getDay();
  var oldDate = date.getDate();
  switch (unit) {
    case "year" /* Year */:
      date.setMonth(0);
    case "month" /* Month */:
      date.setDate(1);
    case "week" /* Week */:
    case "day" /* Day */:
      date.setHours(0);
    case "hour" /* Hour */:
      date.setMinutes(0);
    case "minute" /* Minute */:
      date.setSeconds(0);
    case "second" /* Second */:
      date.setMilliseconds(0);
  }
  if (unit === "week" /* Week */) {
    var diff = (dayOfWeek - options.startDay + 7) % 7;
    date.setDate(oldDate - diff);
  }
  return date;
}

/**
 *
 * @name endOf
 * @summary Return the end of a given time unit for the given date
 * The result will be in the local timezone.
 * @description
 * Return the end date of year/month/day/hour/... for a given date
 *
 * @param {UNIT} unit - the end of this unit, {@link #UNIT}
 * @param {number | string | Date} base - the original date
 * @param {WeekOption} [options={startDay: 1}] - to specify the start day of a week, defaults to `Monday`
 * @returns {Date} The end date of the unit
 * @throws {TypeError} invalid unit or date or start day
 *
 * @example
 * const firstDayOfMonth = startOf('month', Date.now())
 * // if we want the week to start on Sunday
 * const startOfThisWeek = startOf('week', Date.now(), {startDay: 0})
 */
function endOf(unit, base) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    startDay: 1
  };
  var date = new Date(base);
  if (!_isValidUnit(unit) || !_isValidDate(date) || !_isInteger(options.startDay)) {
    throw new TypeError('Invalid unit or date or start day');
  }
  var dayOfWeek = date.getDay();
  var oldDate = date.getDate();
  switch (unit) {
    case "year" /* Year */:
      date.setMonth(11);
    case "month" /* Month */:
      date.setMonth(date.getMonth() + 1, 0);
    case "week" /* Week */:
    case "day" /* Day */:
      date.setHours(23);
    case "hour" /* Hour */:
      date.setMinutes(59);
    case "minute" /* Minute */:
      date.setSeconds(59);
    case "second" /* Second */:
      date.setMilliseconds(999);
  }
  if (unit === "week" /* Week */) {
    var diff = (dayOfWeek - options.startDay + 7) % 7;
    date.setDate(oldDate - diff + 6);
  }
  return date;
}

/**
 *
 * @name convertUnit
 * @summary Return a value in one unit to another
 * @description
 * Return the value in another unit equivalent to the time in the given unit
 * The conversion is inaccurate when involving month and year values,
 * this is because it conveniently ignores leap year / month,
 * 365 days per year and 30 days per month are assumed
 *
 * @param {number} value - the value in from unit
 * @param {UNIT} fromUnit - the unit for the given value
 * @param {UNIT} [toUnit='millisecond'] - the unit to be converted to
 * @returns {number} the equivalent value in new unit
 * @throws {TypeError} invalid unit or value
 *
 * @example
 * const daysInYear = convertUnit(2, 'year', 'day');
 */
function convertUnit(value, fromUnit) {
  var toUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "millisecond";
  if (!_isInteger(value) || !_isValidUnit(fromUnit) || !_isValidUnit(toUnit)) {
    throw new TypeError('Invalid unit or value');
  }
  if (fromUnit === toUnit) {
    return value;
  }
  // units from large to small
  var from = UNITS.indexOf(fromUnit);
  var to = UNITS.indexOf(toUnit);
  var DAY = 3; // UNITS.indexOf('day');
  var exp = to - from > 0 ? 1 : -1;
  // special case for from y to M or vice versa
  if (from + to === 1) {
    return value * Math.pow(12, exp);
  }
  value *= (from < DAY ? RATES[from] : 1) / (to < DAY ? RATES[to] : 1);
  var start = Math.max(Math.min(from, to), DAY);
  var end = Math.max(from, to, DAY);
  return RATES.slice(start, end).reduce(function (p, r) {
    return p * Math.pow(r, exp);
  }, value);
}
/**
 *
 * @name timeBetween
 * @summary Return the number of units between two dates
 * @description
 * Return time in given unit between two dates
 * The conversion is inaccurate when involving month and year values,
 * this is because it conveniently ignores leap year / month,
 * 365 days per year and 30 days per month are assumed
 * If `round = true`, it will round the absolute value while keeping the sign
 *
 * @param {UNIT} unit - the unit to be measured
 * @param {number | string | Date} to - the date to compare to
 * @param {number | string | Date} [from=Date.now()] - the date to compare from
 * @param {boolean} [round=false] - if the value should be rounded up to integer
 * @returns {number} the number of units between dates
 * @throws {TypeError} invalid unit or dates
 *
 * @example
 * const daysApart = timeBetween('day', dateTo, dateFrom);
 * const daysFromNow = timeBetween('day', dateTo);
 * // round value to integer
 * const aboutDaysApart = timeBetween('day', dateTo, dateFrom, true);
 */
function timeBetween(unit, to) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var round = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  to = new Date(to);
  from = new Date(from);
  if (!_isValidDate(to) || !_isValidDate(from) || !_isValidUnit(unit)) {
    throw new TypeError('Invalid unit or dates');
  }
  var diff = convertUnit(+to - +from, "millisecond" /* Millisecond */, unit);
  return round ? diff > 0 ? Math.ceil(diff) : Math.floor(diff) : diff;
}
var locale = {
  separator: ' ',
  suffix: ['# ago', 'in #'],
  year: ['a year', '# year', '# years'],
  month: ['a month', '# month', '# months'],
  week: ['a week', '# week', '# weeks'],
  day: ['a day', '# day', '# days'],
  hour: ['an hour', '# hour', '# hours'],
  minute: ['a minute', '# minute', '# minutes'],
  second: ['a few seconds', '# second', '# seconds'],
  millisecond: ['', '']
};
var locale$1 = {
  separator: '',
  suffix: ['#前', '#内'],
  year: ['一年', '#年'],
  month: ['一个月', '#个月'],
  week: ['一周', '#周'],
  day: ['一天', '#天'],
  hour: ['一小时', '#小时'],
  minute: ['一分钟', '#分钟'],
  second: ['几秒', '#秒'],
  millisecond: ['', '']
};
var locale$2 = {
  separator: ' ',
  suffix: ['# yang lalu', 'dalam #'],
  year: ['setahun', '# tahun'],
  month: ['sebulan', '# bulan'],
  week: ['seminggu', '# minggu'],
  day: ['sehari', '# hari'],
  hour: ['sejam', '# jam'],
  minute: ['semenit', '# menit'],
  second: ['beberapa detik', '# detik'],
  millisecond: ['', '']
};
var locale$3 = {
  separator: ' ',
  suffix: ['# yang lepas', 'dalam #'],
  year: ['setahun', '# tahun'],
  month: ['sebulan', '# bulan'],
  week: ['seminggu', '# minggu'],
  day: ['sehari', '# hari'],
  hour: ['sejam', '# jam'],
  minute: ['seminit', '# minit'],
  second: ['beberapa saat', '# saat'],
  millisecond: ['', '']
};
var locale$4 = {
  separator: ' ',
  suffix: ['#ที่แล้ว', 'อีก #'],
  year: ['1 ปี', '# ปี'],
  month: ['1 เดือน', '# เดือน'],
  week: ['1 สัปดาห์', '# สัปดาห์'],
  day: ['1 วัน', '# วัน'],
  hour: ['1 ชั่วโมง', '# ชั่วโมง'],
  minute: ['1 นาที', '# นาที'],
  second: ['ไม่กี่วินาที', '# วินาที'],
  millisecond: ['', '']
};
var locale$5 = {
  separator: '',
  suffix: ['#前', '#內'],
  year: ['一年', '#年'],
  month: ['一個月', '#個月'],
  week: ['一週', '#週'],
  day: ['一天', '#天'],
  hour: ['一小時', '#小時'],
  minute: ['一分鐘', '#分鐘'],
  second: ['幾秒', '#秒'],
  millisecond: ['', '']
};
var locale$6 = {
  separator: ' ',
  suffix: ['# trước', '# tới'],
  year: ['một năm', '# năm'],
  month: ['một tháng', '# tháng'],
  week: ['một tuần', '# tuần'],
  day: ['một ngày', '# ngày'],
  hour: ['một giờ', '# giờ'],
  minute: ['một phút', '# phút'],
  second: ['vài giây', '# giây'],
  millisecond: ['', '']
};
var locale$7 = {
  separator: ' ',
  suffix: ['há #', 'em #'],
  year: ['um ano', '# ano', '# anos'],
  month: ['um mês', '# mês', '# meses'],
  week: ['uma semana', '# semana', '# semanas'],
  day: ['um dia', '# dia', '# dias'],
  hour: ['uma hora', '# hora', '# horas'],
  minute: ['um minuto', '# minuto', '# minutos'],
  second: ['poucos segundos', '# segundo', '# segundos'],
  millisecond: ['', '']
};
var locale$8 = {
  separator: ' ',
  suffix: ['hace #', 'en #'],
  year: ['un año', '# año', '# años'],
  month: ['un mes', '# mes', '# meses'],
  week: ['una semana', '# semana', '# semanas'],
  day: ['un día', '# día', '# días'],
  hour: ['una hora', '# hora', '# horas'],
  minute: ['un minuto', '# minuto', '# minutos'],
  second: ['unos pocos segundos', '# segundo', '# segundos'],
  millisecond: ['', '']
};
var AR = _objectSpread(_objectSpread({}, locale$8), {}, {
  second: ['hace unos segundos', '# segundo', '# segundos']
});
var locale$9 = {
  separator: ' ',
  suffix: ['# temu', 'w #'],
  year: ['rok', '# rok', '# lat(a)'],
  month: ['miesiąc', '# miesiąc', '# miesięcy/e'],
  week: ['tydzień', '# tydzień', '# tygodnie'],
  day: ['dzień', '# dzień', '# dni'],
  hour: ['godzina', '# godzina', '# godzin(y)'],
  minute: ['minuta', '# minuta', '# minut(y)'],
  second: ['kilka sekund', '# sekunda', '# sekund'],
  millisecond: ['', '']
};
var locale$a = {
  separator: ' ',
  suffix: ['il y a #', 'dans #'],
  year: ['un an', '# an', '# ans'],
  month: ['un mois', '# mois', '# mois'],
  week: ['une semaine', '# semaine', '# semaines'],
  day: ['un jour', '# jour', '# jours'],
  hour: ['une heure', '# heure', '# heures'],
  minute: ['une minute', '# minute', '# minutes'],
  second: ['quelques secondes', '# seconde', '# secondes'],
  millisecond: ['', '']
};
var locale$b = {
  separator: ' ',
  suffix: ['# पहले', '# में'],
  year: ['एक साल', '# साल', '# साल'],
  month: ['# महीना', '# महीना', '# महीने'],
  week: ['सप्ताह', '# हफ्ता', '# हफ्तों'],
  day: ['एक दिन', '# दिन', '# दिन'],
  hour: ['एक घंटा', '# घंटा', '# घंटे'],
  minute: ['एक मिनट', '# मिनट', '# मिनट'],
  second: ['कुछ क्षणों', '# क्षण', '# क्षण'],
  millisecond: ['', '']
};
var locales = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': locale,
  CN: locale$1,
  ID: locale$2,
  MY: locale$3,
  PH: locale,
  SG: locale,
  TH: locale$4,
  TW: locale$5,
  VN: locale$6,
  BR: locale$7,
  MX: locale$8,
  CO: locale$8,
  CL: locale$8,
  AR: AR,
  PL: locale$9,
  ES: locale$8,
  FR: locale$a,
  IN: locale$b
});

/**
 * @constant
 * @type {UnitLowerBounds}
 * @default
 * @private
 */
var defaultUnitLowerBounds = {
  year: 3,
  month: 2,
  week: 2,
  day: 2,
  hour: 1,
  minute: 1,
  second: 1,
  millisecond: 1
};
/**
 * @constant
 * @type {number[]}
 * @description accumulated conversion rates to millisecond in descending order
 * @private
 */
var ACC_RATES = RATES.reduceRight(function (res, v, i) {
  return [v * res[Math.max(2 - i, 0)]].concat(res);
}, [1]);
/**
 * @name formatDuration
 * @summary format the duration between two dates in a given locale
 * @description
 * Format the duration between two dates in a given locale, the smallest unit is second
 * The locale value can be obtained from `durationLocales[LOCALE]`
 * By default, the formatted string contains the largest 2 units
 * Options:
 * - _totalUnits_: number of units to show, default 2; ignored if < 1
 * - _startUnit_: the first unit to show, if set will always start from the unit
 * - _endUnit_: the last unit to show, if set will always end at the unit
 * - _addSuffix_: if true will add tense suffix such as 'in #' or '# ago'
 * - _useWords_: if true will use 'a/an' to replace the singular form
 * - _numberFormat_: if 'numeric', show the original number; if '2-digit', always show 2-digit number
 * - _roundLast_: the rounding behaviour for the last unit, default is 'round'
 * - _unitLowerBounds_: determines the minimum value for a unit to be shown as the first unit
 *                    For example, `{month: 5}` means only show month as first unit if > 5 month
 *                    Default:
 *                      < 2 days will show hours
 *                      < 2 weeks will show days
 *                      < 2 month will show days
 *                      < 3 years will show months
 *
 * @param {DurationLocale} locale - the locale values to be used
 * @param {number | string | Date} to - to the date
 * @param {number | string | Date} from - from the date
 * @param {FormatDurationOption} [options={totalUnits: 2, numberFormat: 'numeric'}] - additional options for formatting
 * @returns {string} formatted string
 * @throws {TypeError} invalid from date or to date
 *
 * @example
 *
 * const from = Date.now();
 * const to = addDuration(from, {month: 4, day: 1, hour: 3});
 * const format = formatDuration.bind(null, durationLocales.SG, to, from);
 *
 * let result = format({totalUnits: 4}) // '4 months 1 day 3 hours 0 minutes'
 * result = format({startUnit: 'year'}) // '0 years 4 months'
 * result = format({includeWeek: true}) // '4 months 0 weeks'
 * result = format({addSuffix: true}) // 'in 4 months 1 day'
 * result = format({useWords: true}) // '4 months a day'
 * result = format({numberFormat: '2-digit'}) // '04 months 01 days'
 * result = format({roundLast: 'ceil'}) // '4 months 2 day'
 * result = format({unitLowerBounds: {month: 5}}) // '121 days 3 hours'
 */
function formatDuration(locale, to) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  try {
    to = new Date(to);
    from = new Date(from);
    if (!locale || !_isValidDate(from) || !_isValidDate(to)) {
      throw new TypeError('Invalid locale or from/to dates');
    }
    var _options$unitLowerBou = options.unitLowerBounds,
      unitLowerBounds = _options$unitLowerBou === void 0 ? {} : _options$unitLowerBou,
      _options$startUnit = options.startUnit,
      startUnit = _options$startUnit === void 0 ? null : _options$startUnit,
      _options$endUnit = options.endUnit,
      endUnit = _options$endUnit === void 0 ? null : _options$endUnit,
      _options$totalUnits = options.totalUnits,
      totalUnits = _options$totalUnits === void 0 ? 0 : _options$totalUnits,
      _options$useWords = options.useWords,
      useWords = _options$useWords === void 0 ? false : _options$useWords,
      _options$includeWeek = options.includeWeek,
      includeWeek = _options$includeWeek === void 0 ? false : _options$includeWeek,
      _options$addSuffix = options.addSuffix,
      addSuffix = _options$addSuffix === void 0 ? false : _options$addSuffix,
      _options$numberFormat = options.numberFormat,
      numberFormat = _options$numberFormat === void 0 ? "numeric" : _options$numberFormat,
      _options$roundLast = options.roundLast,
      roundLast = _options$roundLast === void 0 ? "round" : _options$roundLast;
    var bounds = _objectSpread(_objectSpread({}, defaultUnitLowerBounds), unitLowerBounds);
    if (startUnit && !UNITS.includes(startUnit) || endUnit && !UNITS.includes(endUnit)) {
      throw new RangeError('Invalid start or end units');
    }
    var isFuture = to >= from;
    if (!isFuture) {
      var _ref = [from, to];
      to = _ref[0];
      from = _ref[1];
    }
    var timeDiff = +to - +from;
    var sIndex = 6; // UNITS.indexOf('second')
    var wIndex = 2; // UNITS.indexOf('week);
    // start unit is the largest unit subjected to bound
    // change unit to second if millisecond
    var start = startUnit ? Math.min(UNITS.indexOf(startUnit), sIndex) : UNITS.findIndex(function (u, i) {
      return u === "second" /* Second */ || timeDiff >= ACC_RATES[i] * bounds[u];
    });
    var end = Math.min(UNITS.indexOf(endUnit || "second" /* Second */), sIndex) + 1;
    // set start to end if end unit comes before
    start = Math.min(start, end - 1);
    var count = totalUnits > 0 ? totalUnits : endUnit ? end - start : 2;
    var formats = [];
    var yDiff = to.getFullYear() - from.getFullYear();
    var mDiff = to.getMonth() - from.getMonth();
    var dDiff = to.getDate() - from.getDate();
    if (dDiff < 0) {
      var daysInLastMonth = new Date(to.getFullYear(), to.getMonth(), 0).getDate();
      dDiff += daysInLastMonth + Math.max(0, from.getDate() - daysInLastMonth);
      mDiff--;
    }
    if (mDiff < 0) {
      mDiff += 12;
      yDiff--;
    }
    for (var i = start;; i++) {
      if (i === wIndex) {
        i++;
      }
      var unit = UNITS[i];
      var value = timeDiff / ACC_RATES[i];
      var isFirst = formats.length === 0;
      if (unit === "day" /* Day */) {
        if (!isFirst) {
          value = dDiff + value % 1;
        }
        if (includeWeek && (!isFirst || value >= 7 * bounds.week || startUnit === "week" /* Week */)) {
          formats.push(["week" /* Week */, value / 7]);
          value %= 7;
        }
      } else if (unit === "month" /* Month */) {
        // use largest daysInMonth to avoid over-rounding
        value = mDiff + dDiff / 31 + Number(isFirst && yDiff * 12);
      } else if (unit === "year" /* Year */) {
        value = yDiff + mDiff / 12;
      }
      if (i >= end || formats.length >= count) {
        break;
      }
      formats.push([unit, value]);
      timeDiff %= ACC_RATES[i];
    }
    var separator = locale.separator,
      suffix = locale.suffix;
    var rounding = typeof roundLast === 'function' ? roundLast.apply(void 0, _toConsumableArray(formats[formats.length - 1])) : roundLast;
    var formatted = formats.map(function (_ref2, i, arr) {
      var _ref3 = _slicedToArray(_ref2, 2),
        u = _ref3[0],
        v = _ref3[1];
      // options: [word, singular, plural]
      v = i === arr.length - 1 ? Math[rounding](v) : Math.floor(v);
      var inWords = useWords && (v === 1 || v < 10 && u === "second" /* Second */);
      var idx = inWords ? 0 : v === 1 ? 1 : 2;
      var format = locale[u] ? locale[u][idx] || locale[u][idx - 1] : '#';
      var str = numberFormat === "2-digit" /* Double */ ? _padString(v) : String(v);
      return format.replace('#', str);
    }).filter(Boolean).join(separator);
    return addSuffix ?
    // suffix: [ago, in]
    suffix[Number(isFuture)].replace('#', formatted) : formatted;
  } catch (e) {
    console.warn(e);
    return '';
  }
}

/**
 * @name durationLocale
 * @summary duration locale values
 *
 * @example
 * const locale = durationLocale['SG'];
 */
var durationLocales = locales;
var locale$c = {
  useLocale: 'en-US',
  order: 'wdMyhmsS',
  dateLiteral: ' ',
  monthShortValues: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sept,Oct,Nov,Dec'.split(','),
  monthValues: 'January,February,March,April,May,June,July,August,September,October,November,December'.split(','),
  weekShortValues: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
  weekValues: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday'.split(',')
};
var WEEKDAYS = '日一二三四五六';
var locale$d = {
  useLocale: 'zh-CN',
  order: 'yMdhmsSw',
  dateLiteral: '-',
  dateLiteralWord: '',
  weekShortValues: WEEKDAYS.split('').map(function (v) {
    return '周' + v;
  }),
  weekValues: WEEKDAYS.split('').map(function (v) {
    return '星期' + v;
  }),
  transform: function transform(date, parts, options) {
    ["year" /* Year */, "month" /* Month */, "day" /* Day */].forEach(function (u, i) {
      return (options[u] === "long" /* Long */ || options[u] === "short" /* Short */) && (parts[u] = String(Number(parts[u])) + '年月日'[i]);
    });
  }
};
var locale$e = {
  useLocale: 'id-ID',
  order: 'wdMyhmsS',
  dateLiteral: ' ',
  monthShortValues: 'Jan,Feb,Mar,Apr,Mei,Jun,Jul,Ags,Sep,Okt,Nov,Des'.split(','),
  monthValues: 'Januari,Februari,Maret,April,Mei,Juni,Juli,Agustus,September,Oktober,November,Desember'.split(','),
  transform: function transform(date, parts, options) {
    parts.month = options.month === 'short' && date.getMonth() === 7 ? 'Ags' : parts.month;
  },
  weekShortValues: 'Min,Sen,Sel,Rab,Kam,Jum,Sab'.split(','),
  weekValues: 'Minggu,Senin,Selasa,Rabu,Kamis,Jumat,Sabtu'.split(',')
};
var locale$f = {
  useLocale: 'ms-MY',
  order: 'wdMyhmsS',
  dateLiteral: ' ',
  monthShortValues: 'Jan,Feb,Mac,Apr,Mei,Jun,Julai,Og,Sept,Okt,Nov,Dis'.split(','),
  monthValues: 'Januari,Februari,Mac,April,Mei,Jun,Julai,Ogos,September,Oktober,November,Disember'.split(','),
  weekShortValues: 'Ahd,Isn,Sel,Rab,Kha,Jum,Sab'.split(','),
  weekValues: 'Ahad,Isnin,Selasa,Rabu,Khamis,Jumaat,Sabtu'.split(',')
};
var locale$g = _objectSpread(_objectSpread({}, locale$c), {}, {
  useLocale: 'en-PH'
});
var locale$h = _objectSpread(_objectSpread({}, locale$c), {}, {
  useLocale: 'en-SG'
});
var locale$i = {
  useLocale: 'th-TH',
  order: 'wdMyhmsS',
  dateLiteral: ' ',
  monthShortValues: 'ม.ค.,ก.พ.,มี.ค.,เม.ย.,พ.ค.,มิ.ย.,ก.ค.,ส.ค.,ก.ย.,ต.ค.,พ.ย.,ธ.ค.'.split(','),
  monthValues: 'มกราคม,กุมภาพันธ์,มีนาคม,เมษายน,พฤษภาคม,มิถุนายน,กรกฎาคม,สิงหาคม,กันยายน,ตุลาคม,พฤศจิกายน,ธันวาคม'.split(','),
  weekShortValues: 'อา.,จ.,อ.,พ.,พฤ.,ศ.,ส.'.split(','),
  weekValues: 'วันอาทิตย์,วันจันทร์,วันอังคาร,วันพุธ,วันพฤหัสบดี,วันศุกร์,วันเสาร์'.split(',')
};
var locale$j = _objectSpread(_objectSpread({}, locale$d), {}, {
  useLocale: 'zh-TW',
  weekShortValues: WEEKDAYS.split('').map(function (v) {
    return '週' + v;
  })
});
var locale$k = {
  useLocale: 'vn-VN',
  order: 'whmsSdMy',
  dateLiteral: ' ',
  monthShortValues: Array.from({
    length: 12
  }).map(function (v, i) {
    return 'Th' + String(101 + i).slice(-2);
  }),
  monthValues: Array.from({
    length: 12
  }).map(function (v, i) {
    return 'Tháng ' + String(i + 1);
  }),
  weekShortValues: 'CN,T2,T3,T4,T5,T6,T7'.split(','),
  weekValues: 'chủ nhật,thứ hai,thứ ba,thứ tư,thứ năm,thứ sáu,thứ bảy'.split(',')
};
var locale$l = {
  useLocale: 'pt-BR',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: ' \\de ',
  monthShortValues: 'jan,fev,mar,abr,mai,jun,jul,ago,set,out,nov,dez'.split(','),
  monthValues: 'janeiro,fevereiro,março,abril,maio,junho,julho,agosto,setembro,outubro,novembro,dezembro'.split(','),
  weekShortValues: 'dom,seg,ter,qua,qui,sex,sáb'.split(','),
  weekValues: 'domingo,segunda-feira,terça-feira,quarta-feira,quinta-feira,sexta-feira,sábado'.split(',')
};
var locale$m = {
  useLocale: 'es-MX',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: ' \\de ',
  monthShortValues: 'ene.,feb.,mar.,abr.,may.,jun.,jul.,ago.,sep.,oct.,nov.,dic.'.split(','),
  monthValues: 'enero,febrero,marzo,abril,mayo,junio,julio,agosto,septiembre,octubre,noviembre,diciembre'.split(','),
  weekShortValues: 'dom.,lun.,mar.,mié.,jue.,vie.,sáb.'.split(','),
  weekValues: 'domingo,lunes,martes,miércoles,jueves,viernes,sábado'.split(',')
};
var locale$n = _objectSpread({}, locale$m);
var locale$o = _objectSpread({}, locale$m);
var locale$p = _objectSpread({}, locale$m);
var locale$q = {
  useLocale: 'es-AR',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: ' \\de ',
  monthShortValues: 'ene.,feb.,mar.,abr.,may.,jun.,jul.,ago.,sep.,oct.,nov.,dic.'.split(','),
  monthValues: 'enero,febrero,marzo,abril,mayo,junio,julio,agosto,septiembre,octubre,noviembre,diciembre'.split(','),
  weekShortValues: 'dom.,lun.,mar.,mié.,jue.,vie.,sáb.'.split(','),
  weekValues: 'domingo,lunes,martes,miércoles,jueves,viernes,sábado'.split(',')
};
var locale$r = {
  useLocale: 'pl',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: '',
  monthShortValues: 'stycz.,luty,mar.,kwiec.,maj,czerw.,lip.,sierp.,wrzes.,pazdz.,listop.,grudz.'.split(','),
  monthValues: 'Styczeń,Luty,Marzec,Kwiecień,Maj,Czerwiec,Lipiec,Sierpień,Wrzesień,Październik,Listopad,Grudzień'.split(','),
  weekShortValues: 'nie.,pon.,wt.,śr.,czw.,pią.,sob.'.split(','),
  weekValues: 'Niedziela,Poniedziałek,Wtorek,Środa,Czwartek,Piątek,Sobota'.split(',')
};
var locale$s = {
  useLocale: 'es-ES',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: ' \\de ',
  monthShortValues: 'ene.,feb.,mar.,abr.,may.,jun.,jul.,ago.,sep.,oct.,nov.,dic.'.split(','),
  monthValues: 'enero,febrero,marzo,abril,mayo,junio,julio,agosto,septiembre,octubre,noviembre,diciembre'.split(','),
  weekShortValues: 'dom.,lun.,mar.,mié.,jue.,vie.,sáb.'.split(','),
  weekValues: 'domingo,lunes,martes,miércoles,jueves,viernes,sábado'.split(',')
};
var locale$t = {
  useLocale: 'fr',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: '',
  monthShortValues: 'janv.,févr.,mars,avril,mai,juin,juil.,août,sept.,oct.,nov.,déc.'.split(','),
  monthValues: 'janvier,février,mars,avril,mai,juin,juillet,aout,septembre,octobre,novembre,décembre'.split(','),
  weekShortValues: 'dim.,lun.,mar.,mer.,jeu.,ven.,sam.'.split(','),
  weekValues: 'dimanche,lundi,mardi,mercredi,jeudi,vendredi,samedi'.split(',')
};
var locale$u = {
  useLocale: 'hi',
  order: 'wdMyhmsS',
  dateLiteral: '/',
  dateLiteralWord: '',
  monthShortValues: 'जनवरी,फरवरी,मार्च,अप्रैल,मई,जून,जुलाई,अगस्त,सितंबर,अक्टूबर,नवंबर,दिसंबर'.split(','),
  monthValues: 'जनवरी,फरवरी,मार्च,अप्रैल,मई,जून,जुलाई,अगस्त,सितंबर,अक्टूबर,नवंबर,दिसंबर'.split(','),
  weekShortValues: 'रविवार,सोमवार,मंगलवार,बुधवार,गुरुवार,शुक्रवार,शनिवार'.split(','),
  weekValues: 'रविवार,सोमवार,मंगलवार,बुधवार,गुरुवार,शुक्रवार,शनिवार'.split(',')
};
var locales$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': locale$c,
  CN: locale$d,
  ID: locale$e,
  MY: locale$f,
  PH: locale$g,
  SG: locale$h,
  TH: locale$i,
  TW: locale$j,
  VN: locale$k,
  BR: locale$l,
  MX: locale$n,
  CO: locale$o,
  CL: locale$p,
  AR: locale$q,
  PL: locale$r,
  ES: locale$s,
  FR: locale$t,
  IN: locale$u
});
var regex = /\\?(y+|M+|w+|d+|h+|m+|s+|S+)/g;
var patternMap = new Map();
var configMap = new Map();
/**
 *
 * @name _parsePattern
 * @private
 * @summary helper to convert format string into format options
 *
 * @param {string} pattern - format pattern as combination of units
 * @param {FormatConfig} override
 */
function _parsePattern(pattern) {
  if (patternMap.get(pattern) !== undefined) {
    return patternMap.get(pattern);
  }
  var config = {};
  var result = pattern.replace(regex, function (escapedStr, formatStr) {
    var literal = escapedStr === formatStr ? '' : escapedStr.slice(0, 2);
    formatStr = escapedStr === formatStr ? formatStr : escapedStr.slice(2);
    if (!formatStr) {
      return literal;
    }
    var unit = KEY_UNIT_MAP[formatStr[0]];
    var idx = formatStr[0] === "y" /* Year */ && formatStr.length === 4 ? 0 : Math.min(formatStr.length - 1, 3);
    config[unit] = FORMATS[idx];
    return literal + formatStr[0];
  });
  patternMap.set(pattern, [result, config]);
  return [result, config];
}
/**
 * @name _createPattern
 * @private
 * @summary helper to convert format options into format pattern
 *
 * @param {FormatOption} options - the format options to be converted
 * @returns {string} the pattern converted from the options
 */
function _createPattern(options) {
  var key = JSON.stringify(options);
  if (configMap.get(key) !== undefined) {
    return configMap.get(key);
  }
  var _options$order = options.order,
    order = _options$order === void 0 ? 'wdMyhmsS' : _options$order,
    _options$dateLiteral = options.dateLiteral,
    dateLiteral = _options$dateLiteral === void 0 ? '/' : _options$dateLiteral,
    _options$dateLiteralW = options.dateLiteralWord,
    dateLiteralWord = _options$dateLiteralW === void 0 ? options.dateLiteral || '/' : _options$dateLiteralW,
    _options$timeLiteral = options.timeLiteral,
    timeLiteral = _options$timeLiteral === void 0 ? ':' : _options$timeLiteral,
    _options$separator = options.separator,
    separator = _options$separator === void 0 ? ' ' : _options$separator,
    _options$weekLiteral = options.weekLiteral,
    weekLiteral = _options$weekLiteral === void 0 ? ', ' : _options$weekLiteral,
    _options$msLiteral = options.msLiteral,
    msLiteral = _options$msLiteral === void 0 ? '.' : _options$msLiteral,
    option = _objectWithoutProperties(options, _excluded);
  var DATE = function DATE(s) {
    return 'yMd'.includes(s);
  };
  var TIME = function TIME(s) {
    return 'hms'.includes(s);
  };
  var WEEK = function WEEK(s) {
    return s === "w";
  } /* Week */;
  var result = order.split('').filter(function (k) {
    return !!option[KEY_UNIT_MAP[k]];
  }).reduce(function (s, k, i, a) {
    var values = [k, a[i + 1]];
    var formats = values.map(function (v) {
      return option[KEY_UNIT_MAP[v]];
    });
    var isWordDate = formats.some(function (v) {
      return ["short" /* Short */, "long" /* Long */].includes(v);
    });
    var suffix = i === a.length - 1 ? '' : values.every(DATE) ? isWordDate ? dateLiteralWord : dateLiteral : values.every(TIME) ? timeLiteral : values.some(DATE) && values.some(TIME) ? separator : values.some(WEEK) ? weekLiteral : values[1] === "S" /* Milisecond */ ? msLiteral : '';
    return s + k + suffix;
  }, '');
  configMap.set(key, result);
  return result;
}
/**
 * @name _formatToParts
 * @private
 * @summary an internal implementation of Intl.DateTimeFormat.formatToParts
 *
 * @param {TimeLocale} locale - the locale configuration object
 * @param {Date} date - the raw date to be formatted
 * @param {FormatOption} options - the format options to be converted
 * @returns {Object.<UNIT, string>} a map of units and formatted values
 */
function _formatToParts(locale, date, options) {
  var _rawValues;
  var rawValues = (_rawValues = {}, _defineProperty(_rawValues, "year" /* Year */, date.getFullYear()), _defineProperty(_rawValues, "month" /* Month */, date.getMonth() + 1), _defineProperty(_rawValues, "week" /* Week */, date.getDay()), _defineProperty(_rawValues, "day" /* Day */, date.getDate()), _defineProperty(_rawValues, "hour" /* Hour */, date.getHours()), _defineProperty(_rawValues, "minute" /* Minute */, date.getMinutes()), _defineProperty(_rawValues, "second" /* Second */, date.getSeconds()), _defineProperty(_rawValues, "millisecond" /* Millisecond */, date.getMilliseconds()), _rawValues);
  return UNITS.reduce(function (parts, unit) {
    if (options[unit]) {
      parts[unit] = _formatUnit(locale, rawValues[unit], unit, options[unit]);
    }
    return parts;
  }, {});
}
function _formatUnit(locale, value, unit, format) {
  switch (format) {
    case "numeric" /* Numeric */:
      return String(value);
    case "2-digit" /* Double */:
      return _padString(String(value));
    case "long" /* Long */:
      if (unit === "month" /* Month */ && locale.monthValues) {
        return locale.monthValues[value - 1];
      }
      if (unit === "week" /* Week */ && locale.weekValues) {
        return locale.weekValues[value];
      }
      return _padString(String(value), Math.max(String(value).length, 2));
    case "short" /* Short */:
      if (unit === "month" /* Month */ && locale.monthShortValues) {
        return locale.monthShortValues[value - 1];
      }
      if (unit === "week" /* Week */ && locale.weekShortValues) {
        return locale.weekShortValues[value];
      }
    default:
      return String(value);
  }
}
/**
 * @name formatTime
 * @summary format a given date to a given format in a given locale
 * @description
 * Format the date to a certain format pattern in a given locale
 * The locale value can be obtained from `timeLocales[LOCALE]`
 * The result is based on the local timezone
 * The format can be one of the followings:
 * 1) string - a string pattern formed from format keys, such as y, m, d
 * 2) object - containing a format string and optional key-to-format mappings
 * 3) function - a factory returns a format string form a locale object,
 *               some common formats can be found in `Format` class
 * The function uses `Intl.DateTimeFormat` API, and fallbacks to `Date.prototype.toLocaleDateString`
 *
 * @example
 * const locale = timeLocales.SG;
 * const format = formatTime.bind(null, locale, new Date());
 *
 * // 1) format string
 * let result = format('yy-MM-dd');
 * // 2) format option (same as 'yy-MM-dd')
 * result = format({key: 'y-m-d', options: {year: '2-digit', month: '2-digit', day: '2-digit'}})
 * // 3) format factory
 * result = format(Format.DATE)
 *
 * @param {TimeLocale} locale - the locale values to be used
 * @param {number | string | Date} base - the date to be formatted
 * @param {string | FormatConfig | FormatFactory} format - the format pattern to be formatted
 * @returns {string} formatted string
 * @throws {TypeError} invalid locale or date
 */
function formatTime(locale, base, format) {
  try {
    var date = new Date(base);
    if (!locale || !_isValidDate(date)) {
      throw new TypeError('Invalid locale or date');
    }
    var pattern;
    var options;
    if (typeof format === 'function') {
      format = format(locale);
    }
    if (typeof format === 'string') {
      var _parsePattern2 = _parsePattern(format);
      var _parsePattern3 = _slicedToArray(_parsePattern2, 2);
      pattern = _parsePattern3[0];
      options = _parsePattern3[1];
    } else {
      locale = _objectSpread(_objectSpread({}, locale), format);
      var _ref4 = [_createPattern(locale), format];
      pattern = _ref4[0];
      options = _ref4[1];
    }
    // translate locale values
    var parts = _formatToParts(locale, date, options);
    // perform any transformations
    // transformations use non-normalized options
    if (typeof locale.transform === 'function') {
      locale.transform(date, parts, options);
    }
    // replace values in format string
    return pattern.replace(regex, function (escapedStr, formatStr) {
      var literal = escapedStr === formatStr ? '' : escapedStr.slice(1, 2);
      var key = escapedStr === formatStr ? formatStr : escapedStr.slice(2);
      var value = parts[KEY_UNIT_MAP[key]] || '';
      return literal + value;
    });
  } catch (e) {
    console.warn(e);
    return '';
  }
}

/**
 * @class Format
 * @classdesc a class for common formats
 * @hideconstructor
 */
var Format = /*#__PURE__*/function () {
  function Format() {
    _classCallCheck(this, Format);
  }
  _createClass(Format, null, [{
    key: "DATE",
    value:
    /**
     * @static
     * @param {TimeLocale} locale
     * @returns {FormatOption} date format
     */
    function DATE(locale) {
      var config = {
        'en-PH': {
          dateLiteral: '/',
          order: 'wMdyhmsS'
        },
        'pt-BR': {
          dateLiteral: '/'
        },
        'es-MX': {
          dateLiteral: '/'
        },
        'es-CO': {
          dateLiteral: '/'
        },
        'es-CL': {
          dateLiteral: '/'
        },
        'es-AR': {
          dateLiteral: '/'
        },
        pl: {
          dateLiteral: '/'
        },
        'es-ES': {
          dateLiteral: '/'
        },
        fr: {
          dateLiteral: '/'
        }
      };
      return _objectSpread({
        dateLiteral: '-',
        day: '2-digit',
        year: 'numeric',
        month: '2-digit'
      }, config[locale.useLocale]);
    }
    /**
     * @static
     * @param {TimeLocale} locale
     * @returns {FormatOption} datetime format
     */
  }, {
    key: "DATE_TIME",
    value: function DATE_TIME(locale) {
      return _objectSpread(_objectSpread({}, Format.DATE(locale)), {}, {
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    /**
     * @static
     * @param {TimeLocale} locale
     * @returns {FormatOption} short datetime format
     */
  }, {
    key: "DATE_TIME_SHORT",
    value: function DATE_TIME_SHORT(locale) {
      return _objectSpread(_objectSpread({}, Format.DATE_TIME(locale)), {}, {
        year: '2-digit'
      });
    }
    /**
     * @static
     * @param {TimeLocale} locale
     * @returns {string} from date format
     */
  }, {
    key: "FROM_DATE",
    value: function FROM_DATE(locale) {
      var config = {
        'zh-CN': {
          year: 'long',
          day: 'short'
        },
        'zh-TW': {
          year: 'long',
          day: 'short'
        },
        'es-MX': {
          month: 'long'
        },
        'es-CO': {
          month: 'long'
        },
        'es-CL': {
          month: 'long'
        }
      };
      return _objectSpread({
        month: 'short',
        day: 'numeric'
      }, config[locale.useLocale]);
    }
    /**
     * @static
     * @param {TimeLocale} locale
     * @returns {string} to date format
     */
  }, {
    key: "TO_DATE",
    value: function TO_DATE(locale) {
      var config = {
        'zh-CN': {
          year: undefined,
          day: 'short'
        },
        'zh-TW': {
          year: undefined,
          day: 'short'
        },
        'es-MX': {
          month: 'long'
        },
        'es-CO': {
          month: 'long'
        },
        'es-CL': {
          month: 'long'
        }
      };
      return _objectSpread({
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }, config[locale.useLocale]);
    }
    /**
     * @static
     * @param {UNIT[]} units
     * @returns {FormatFactory} factory to generate date format
     */
  }, {
    key: "NATURAL_DATE",
    value: function NATURAL_DATE() {
      var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['day', 'month'];
      return function (locale) {
        var formats = {
          year: 'long',
          month: ['vn-VN', 'th-TH', 'es-MX', 'es-CO', 'es-CL'].includes(locale.useLocale) ? 'long' : 'short',
          day: 'short',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          week: 'short',
          millisecond: 'numeric'
        };
        return units.reduce(function (o, v) {
          return _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, v, formats[v]));
        }, {});
      };
    }
  }]);
  return Format;
}();
/**
 * @name timeLocales
 * @summary time locale values
 *
 * @example
 * const locale = timeLocales['SG'];
 */
var timeLocales = locales$1;
export { Format, addDuration, addUnit, convertUnit, durationLocales, endOf, formatDuration, formatTime, startOf, timeBetween, timeLocales };